module.exports = __webpack_public_path__ + "img/succ-bg1.f134e0f8.png";